import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddService from '../models/AddService';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';

const Services = () => {
 // near top of component
const [toggleStates, setToggleStates] = useState({});
const [loadingToggles, setLoadingToggles] = useState({}); // track per-id loading

// call this after initData to initialize states from server items
const initToggleStatesFromRecords = (records) => {
  const map = {};
  (records || []).forEach(r => {
    // adjust key name if server returns 'is_default' or 'cat_default' or 'cat_type3' etc
    map[r.cat_id] = r.is_default === 1 || r.is_default === "1" || r.cat_default === 1 || r.cat_default === "1";
  });
  setToggleStates(map);
};


const handleToggle = async (id) => {
  if (!id) return;
  // avoid double toggle while this id is updating
  if (loadingToggles[id]) return;

  const prev = !!toggleStates[id];
  // optimistic UI update
  setToggleStates((s) => ({ ...s, [id]: !prev }));
  setLoadingToggles((l) => ({ ...l, [id]: true }));

  try {
    const fd = new FormData();
    fd.append('cat_id', id + "");
    // send new desired value: 1 or 0
    fd.append('is_default', (!prev ? 1 : 0) + "");

    const resp = await axios.post(AppConst.BASE_URL + AppConst.updateCatDefaultUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (!resp || !resp.data || resp.data.status !== true) {
      throw new Error((resp && resp.data && (resp.data.message || resp.data.success)) || "Failed to update");
    }
    // optionally show success toast
    toast.success("Updated");
  } catch (err) {
    console.error("Toggle update failed", err);
    // rollback UI
    setToggleStates((s) => ({ ...s, [id]: prev }));
    toast.error("Failed to update default flag");
  } finally {
    setLoadingToggles((l) => {
      const copy = { ...l };
      delete copy[id];
      return copy;
    });
  }
};

  const [formData, setFormData] = useState({
    l1: [],
    cat_type: 'service',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    search_key:'',
    isAlert: false,
  });
   const [isAdmin , setIsAdmin] = useState('')
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (storedData) {
      const parsed = JSON.parse(storedData);
      const fd = new FormData();
      fd.append('cat_type', formData.cat_type + "");
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('par_by', 1 + "");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.data.status) {
          const records = response.data.records;
          if (records) {
            setFormData(prev => ({
              ...prev,
              l1: records
            }));
            // initialize toggleStates from DB values
            initToggleStatesFromRecords(records);
          } else {
            setFormData(prev => ({ ...prev, l1: [] }));
            setToggleStates({}); // reset if nothing
          }
        }
        
      } catch (error) {

      }
    }
  };

  const handleChange = (e) => {
       
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const delItem = async (editItem) => {
    const fd = new FormData();
    fd.append('cat_id', editItem.cat_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delCatUrl, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status) {
        initData();
        toast.success('Delete Successfully');
      }
    } catch (error) {

    }
  };

  const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };

  useEffect(() => {
    //console.log('Component mounted');
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }

    return () => {
      //console.log('Component unmounted');
    };
  }, []);

   const filteredList = formData.search_key.trim() === ""
  ? formData.l1
  : formData.l1.filter(item =>
      item.cat_name?.toLowerCase().includes(formData.search_key.toLowerCase())
    );
    const customStyles = {
      headCells: {
        style: {
          backgroundColor: '#f1f5fb',
          color: '#405189',
          fontSize: '15px',      // larger header text
          fontWeight: '700',
          paddingLeft: '14px',
          paddingRight: '14px',
        }
      },
      rows: {
        style: {
          fontSize: '16px', // row font size
          minHeight: '58px',
        },
      },
      cells: {
        style: {
          paddingLeft: '14px',
          paddingRight: '14px',
          fontSize: '15px',      // larger body text
          lineHeight: '20px'
        }
      },
    };
    const columns = [
      {
        name: 'SN',
        selector: (row, idx) => filteredList.indexOf(row) + 1,
        width: '70px',
        sortable: false,
      },
      {
        name: 'Service Name',
        selector: (row) => row.cat_name,
        sortable: true,
        wrap: true,
      },
      {
        name: 'Price',
        selector: (row) => row.cat_type1,
        sortable: true,
        width: '110px',
      },
      {
        name: 'Default',
        cell: (row) => (
          <label className="switch">
            <input
              type="checkbox"
              checked={!!toggleStates[row.cat_id]}
              onChange={() => handleToggle(row.cat_id)}
              disabled={!!loadingToggles[row.cat_id] || !isAdmin}
            />
            <span className="slider round"></span>
          </label>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        width: '110px',
      },
      {
        name: 'Description',
        selector: (row) => row.cat_type2,
        sortable: false,
        wrap: true,
      },
      {
        name: 'Action',
        cell: (row) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1 }}
              onClick={() => {
                setEditItem(row);
                document.getElementById('addbt453').click();
              }}
            >
              <i className="ri-pencil-fill fs-16 me-1"></i> Edit
            </button>
    
            <button
              className="btn btn-sm btn-outline-danger"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1 }}
              onClick={() => delItem(row)}
            >
              <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
            </button>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        width: '220px',
      },
    ];
  
  return (
    <div class="page-content">
      <div class="container-fluid">

        <div class="row">
          <div class="col-lg-12">
            <div class="card" id="orderList">
              <div class="card-header border-0">
                <div class="row align-items-center gy-3">
                  <div class="col-sm">
                    <h5 class="card-title mb-0">Services</h5>
                  </div>
                  <div class="col-sm-auto">
                    <div class="d-flex gap-1 flex-wrap">
                    <button id="addbt453" style={{display:"none"}} type="button" class="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal" fdprocessedid="jys8hw">
                    </button>
                      <button type="button" class="btn btn-success add-btn"
                       onClick={(e) => {
                        e.preventDefault();
                        setEditItem(null);
                        document.getElementById("addbt453").click();
                      }}
                      >
                        <i class="ri-add-line align-bottom me-1"></i> Add Service </button>
                      <button class="btn btn-soft-danger" id="remove-actions">
                        <i class="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div class="row g-3">
                    <div class="col-xxl-5 col-sm-6">
                      <div class="search-box">
                        <input class="form-control search"  name="search_key" onChange={handleChange} value={formData.search_key} placeholder="Search by name" type="text" fdprocessedid="ws635j" />
                        <i class="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <br />
              <div class="card-body pt-0">
                <div>

               
  <div className="table-responsive table-card mb-1">
  <DataTable
  columns={columns}
  data={filteredList}
  pagination
  paginationPerPage={20}                      // show pager even on small sets for testing
  paginationRowsPerPageOptions={[5, 10, 20]} // user choices
  paginationComponentOptions={{
    rowsPerPageText: 'Rows per page:',
    rangeSeparatorText: 'of',
    selectAllRowsItem: false,
  }}
  highlightOnHover
  responsive
  persistTableHead
  customStyles={customStyles}
  noHeader
/>
  </div>

                 
                </div>
                <AddService item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
